import { render } from "./WishboardList.vue?vue&type=template&id=435c5923&scoped=true"
import script from "./WishboardList.vue?vue&type=script&lang=js"
export * from "./WishboardList.vue?vue&type=script&lang=js"

import "./WishboardList.vue?vue&type=style&index=0&id=435c5923&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435c5923"]])

export default __exports__